
import React, { PureComponent } from 'react'
import { Modal, Col, Row, Button } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputText from '../../../commons/form/InputText'
import InputSelect from '../../../commons/form/InputSelect'

class ProcessingAgencyIntegrationServiceDestinationsMasterModal extends PureComponent {
  constructor () {
    super()
    this.state = {}
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevProps.showModal !== this.props.showModal && this.props.showModal === true) {
      this.props.initialize(this.props.processingAgencyServiceDestination)
    }
  }

  submitProcessingAgencyServiceDestination (values) {
    const processingAgencyServiceDestination = {
      ProcessingAgencyServiceDestinationId: this.props.processingAgencyServiceDestination?.processingAgencyServiceDestinationId,
      ProcessingAgencyId: this.props.agency.processingAgencyId,
      DestinationUseValue: values.destinationUseValue,
      ServiceDestinationId: values.serviceDestinationId
    }

    this.props.actions.submitProcessingAgencyServiceDestinations(this.props.agency.processingAgencyId, processingAgencyServiceDestination)
  }

  render () {
    const {
      t, handleSubmit,
      showModal
    } = this.props
    const tKey = 'MASTERS.PROCESSING_AGENCY_MASTERS.SERVICE_DESTINATIONS.'
    return (
      <Modal className="role-modal languages-modal integrations-modal-padding" show={showModal} onHide={() => this.props.actions.showProcessingAgencyServiceDestinationsModal(null, false)} backdrop={'static'}>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitProcessingAgencyServiceDestination.bind(this))}>
          <Modal.Header closeButton onHide={() => this.props.actions.showProcessingAgencyServiceDestinationsModal(null, false)}>
            <Modal.Title>{t(`${tKey}SERVICE_DESTINATION`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="inputs-wrapper">
              <Col sm={6} className="custom-width-col">
                <h2>{t(`${tKey}SERVICE_DESTINATION`)}</h2>
                <Field
                  name="serviceDestinationId"
                  placeholder={t(`${tKey}SERVICE_DESTINATION`)}
                  component={InputSelect}
                  valueKey="id"
                  labelKey="value"
                  options={this.props.combos.serviceDestinations}
                  colSm={0}
                />
              </Col>
              <Col sm={6}>
                <h2>{t(`${tKey}PROCESSING_AGENCY_CODE`)}</h2>
                <Field
                  name="destinationUseValue"
                  placeholder={t(`${tKey}PROCESSING_AGENCY_CODE`)}
                  component={InputText}
                  required={[true]}
                  maxLength={50}
                  colSm={0}
                />
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className="btn-wrapper">
              <Button
                id="role-modal-submit-button"
                className="btn-standard"
                type="submit"
                disabled={this.props.pristine}>
                {t(`${tKey}MODAL.SUBMIT_BUTTON`)}
              </Button>
            </Col>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default reduxForm({
  form: 'editProcessingAgencyServiceDestinationModal',
  validate: (values, props) => {
    let error = {}
    const tKey = 'MASTERS.PROCESSING_AGENCY_MASTERS.DOC_TYPE_USES.VALIDATION.'
    if (!values.serviceDestinationId) {
      error.serviceDestinationId = props.t(`${tKey}VALUE_REQUIRED`)
    }
    if (!values.destinationUseValue) {
      error.destinationUseValue = props.t(`${tKey}VALUE_REQUIRED`)
    }

    return Object.keys(error).length > 0 ? error : {}
  }
})(ProcessingAgencyIntegrationServiceDestinationsMasterModal)
